export default function LoadingSpinner() {
  return (
    <div className="relative min-h-screen w-full bg-transparent">
      <div className="relative flex min-h-screen items-center justify-center">
        <div className="text-center">
          <div className="inline-block w-16 h-16 border-4 border-orange-600 border-t-transparent rounded-full animate-spin"></div>
          <p className="mt-4 text-gray-300 font-medium">Loading...</p>
        </div>
      </div>
    </div>
  );
}
